
var $body = $('body'),
		//thisPage = $body.attr('data-page'),
		//site = $body.attr('data-site'),
		//height = $(window).height(),
		width = $(window).width()
;
